
import Button from '@/components/elements/Button.vue'

export default {
  name: 'BackTo',

  components: {
    Button
  },

  props: {
    link: String,
    label: {
      type: String,
      default: '戻る'
    }
  }
}
